import {
  Button,
  Card,
  Col,
  Flex,
  Popconfirm,
  Row,
  Space,
  Tooltip,
  Typography,
} from "antd";
import { Activity, HelpCircle, Pencil, Trash2 } from "lucide-react";
import {useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ExamPeriod } from "@types";
import { getKeycloakRealm, setTimeWithSeconds } from "../helpers";
import { useDeleteExamPeriod, useTenantTimezone } from "@hooks";
import { getTextByExamPeriodStatus } from "./monitor/helpers";
import React from "react";
const Paragraph = Typography;

interface Props {
  examPeriod: ExamPeriod;
}

export const ExamsListItem = React.memo(({examPeriod}: Props) => {

  const navigate = useNavigate();
  const {t} = useTranslation();
  const deleteExamPeriod = useDeleteExamPeriod();
  const { format: formatInTenantTz } = useTenantTimezone();
  return (
    <div style={{ width: "100%", padding: "8px 4px" }}>
      <Card
        bordered={false}
        style={{ boxShadow: "rgba(0, 0, 0, 0.16) 1px 0px 10px" }}
      >
        <Flex justify="space-between" align="top" style={{marginBottom: 12}}>
          <Typography.Title level={4} style={{ marginTop: 0 }}>
            {examPeriod.exam.title}
          </Typography.Title>
          <Space>
            <Link to={`/${getKeycloakRealm}/edit-exam-period/${examPeriod.id}`}>

            <Button icon={<Pencil />} />
            </Link>
            <Tooltip title={t("pages.examPeriods.monitoring")}>
              <Button onClick={() => navigate(`/${getKeycloakRealm}/exam-periods/monitoring/${examPeriod.id}`)} icon={<Activity/>} />
            </Tooltip>
            <Popconfirm
              title={t("pages.examPeriods.deleteExamPeriod")}
              description={t("pages.examPeriods.deleteExamPeriodDesc")}
              onConfirm={() => deleteExamPeriod.mutate(examPeriod.id)}
              okButtonProps={{ loading: deleteExamPeriod.isPending }}
              icon={<HelpCircle style={{ color: "red", marginRight: 8 }} />}
            >
              <Button danger icon={<Trash2 />} />
            </Popconfirm>
          </Space>
        </Flex>
        <Flex justify="space-between" align="flex-end">
          <Space.Compact direction="vertical" style={{width: "50%"}}>
            <Row gutter={16}>
              <Col span={12}>
                <Paragraph id="period_date">
                  <Typography.Text strong>{t("pages.examPeriods.date")}: </Typography.Text>
                  <Typography.Text>{formatInTenantTz(examPeriod.date, "D.M.YYYY")}</Typography.Text>
                </Paragraph>
              </Col>
              <Col span={12}>
                <Paragraph>
                  <Typography.Text strong>{t("pages.examPeriods.contact")}: </Typography.Text>
                  <Typography.Text>{ examPeriod.contact && `${examPeriod.contact.firstName} ${examPeriod.contact.lastName}`}</Typography.Text>
                </Paragraph>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Paragraph>
                  <Typography.Text strong>{t("pages.examPeriods.duration")}: </Typography.Text>
                  <Typography.Text>{setTimeWithSeconds(examPeriod.time).format("H[h] mm[min]")}</Typography.Text>
                </Paragraph>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Paragraph>
                  <Typography.Text strong>{t("pages.examPeriods.place")}: </Typography.Text>
                  <Typography.Text>{examPeriod.examRoom.location}</Typography.Text>
                </Paragraph>
              </Col>
              <Col span={12}>
                <Paragraph>
                  <Typography.Text strong>{t("pages.examPeriods.status")}: </Typography.Text>
                  {getTextByExamPeriodStatus(examPeriod.state, t)}
                </Paragraph>
              </Col>
            </Row>
          </Space.Compact>
         {/* {examPeriod.state === ExamPeriodState.Completed && (
           <Alert
           message={
             <Space.Compact direction="vertical">
               <Typography.Text>{t("pages.examPeriods.examAlert")}</Typography.Text>
               <Typography.Text>
                 <Trans t={t} i18nKey={"pages.examPeriods.examAlertQ"}>
                 Ima {{num}} koje treba
                 ocjeniti.
                 </Trans>
               
               </Typography.Text>
             </Space.Compact>
           }
           type="warning"
           showIcon
         />)} */}
        </Flex>
      </Card>
    </div>
  );
});
